import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Overlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: flex-end;
  z-index: 1000;
  animation: ${fadeIn} 0.2s ease-in-out;
  padding: 0;
`;

export const Container = styled.div<{ isOpen: boolean }>`
  width: 100%;
  background: white;
  border-top-left-radius: 26px;
  border-top-right-radius: 26px;
  padding: 0;
  position: relative;
  max-height: 80vh;
  height: auto;
  animation: ${slideUp} 0.3s ease-in-out;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    border-top-left-radius: 26px;
    border-top-right-radius: 26px;
    max-height: 80vh;
    height: auto;
    display: flex;
    flex-direction: column;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding: 16px 24px 16px 24px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #2e2e2e;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none !important;
  border: none !important;
  padding: 8px !important;
  cursor: pointer !important;
  color: #6e6e6e !important;
  font-size: 24px !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
`;

export const Content = styled.div<{ hasHeader?: boolean }>`
  width: 100%;
  overflow-y: auto;
  flex: 1;
  padding: ${(props) => (props.hasHeader ? '0 24px 24px 24px' : '40px 24px 80px 24px')};
  -webkit-overflow-scrolling: touch;
`;
